export const enum AgeGroups {
  ZeroToFive = '0-4',
  FiveToFifteen = '5-14',
  FifteenToTwentyFive = '15-24',
  TwentyFiveToThirtyFive = '25-34',
  ThirtyFiveToFortyFive = '35-44',
  FortyFiveToFiftyFive = '45-54',
  FiftyFiveToSixtyFive = '55-64',
  SixtyFiveToSeventyFive = '65-74',
  SeventyFiveToEightyFive = '75-84',
  EightyFiveToNinetyFive = '85-94',
  NinetyFiveToHundred = '95-99',
  HundredAbove = '100-above',
}

export const AgeGroupMap = {
  [AgeGroups.ZeroToFive]: {
    startAge: 0,
    endAge: 5,
  },
  [AgeGroups.FiveToFifteen]: {
    startAge: 5,
    endAge: 15,
  },
  [AgeGroups.FifteenToTwentyFive]: {
    startAge: 15,
    endAge: 25,
  },
  [AgeGroups.TwentyFiveToThirtyFive]: {
    startAge: 25,
    endAge: 35,
  },
  [AgeGroups.ThirtyFiveToFortyFive]: {
    startAge: 35,
    endAge: 45,
  },
  [AgeGroups.FortyFiveToFiftyFive]: {
    startAge: 45,
    endAge: 55,
  },
  [AgeGroups.FiftyFiveToSixtyFive]: {
    startAge: 55,
    endAge: 65,
  },
  [AgeGroups.SixtyFiveToSeventyFive]: {
    startAge: 65,
    endAge: 75,
  },
  [AgeGroups.SeventyFiveToEightyFive]: {
    startAge: 75,
    endAge: 85,
  },
  [AgeGroups.EightyFiveToNinetyFive]: {
    startAge: 85,
    endAge: 95,
  },
  [AgeGroups.NinetyFiveToHundred]: {
    startAge: 95,
    endAge: 100,
  },
  [AgeGroups.HundredAbove]: {
    startAge: 100,
    endAge: 110,
  },
};

export interface AgeGroup {
  startAge: number;
  endAge: number;
}
